import CategoryService from "../../services/category-service"

export const makeCategoryService = (): CategoryService => {
  return new CategoryService()
}
